export const CALCULATE_POW_OF_10 = 10;
export const MAX_DECIMALS_TO_APPLY_ROUNDING = 8;
export const POINT_TO_APPLY_ROUNDING = 0.5;
